module.exports = __webpack_public_path__ + "img/full7-min.2ec0a444.png";